import axios from 'axios';
import config from '../OEMConfig';
import { requestEnded, requestStarted } from '../utils/progressBar';
import authStorage from './authStorage';
import { handleSessionExpired } from '../app/session';

const oemConfig = config();

let clientIp = null;
const ipPromise = fetch('https://api.ipify.org?format=json')
  .then((res) => res.json())
  .then((data) => {
    clientIp = data.ip;
    return clientIp;
  })
  .catch(() => {
    clientIp = 'unknown';
    return clientIp;
  });

// Endpoints that are part of the login/auth flow — their 401s are expected
// errors (e.g. wrong credentials) and must NOT trigger the global redirect.
const AUTH_FLOW_ENDPOINTS = ['/login', '/register', '/logout', '/root-user', '/public_v1/bbs-cms/sso/exchange'];
const AUTH_FLOW_PREFIXES = ['/forgot-password', '/reset-password'];

const handleUnauthorized = (error) => {
  if (error.response?.status !== 401) return;

  const path = (error.config?.url || '').split('?')[0];
  const isAuthFlow = AUTH_FLOW_ENDPOINTS.includes(path) || AUTH_FLOW_PREFIXES.some((prefix) => path.startsWith(prefix));
  if (isAuthFlow) return;

  // Only force logout while a session still exists; clearing the token below also
  // makes this idempotent for concurrent 401s.
  if (!authStorage.get('token')) return;

  handleSessionExpired();
};

const axiosInstance = axios.create({
  // Base URL for Local Development
  // baseURL: 'http://127.0.0.1:8000/api',

  // Base URL for Dev Development
  baseURL: oemConfig.http_host,

  headers: {
    'Content-Type': 'application/json',
  },
});

// Progress bar interceptors - request
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = authStorage.get('token');
    const lang = authStorage.get('seolanguage') || 'jp';

    // Ensure token is a valid string before adding to headers
    if (token && token !== 'undefined' && token !== 'null') {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    config.headers['Lang'] = lang === 'jp' ? 'ja' : 'en';
    config.headers['Accept'] = 'application/json';

    try {
      const ip = clientIp || (await ipPromise);
      if (ip && ip !== 'unknown') {
        config.headers['X-Client-Ip'] = ip;
      }
    } catch (e) {
      // ignore fetching failures silently
    }

    // START PROGRESS BAR
    requestStarted();

    return config;
  },
  (error) => {
    // END PROGRESS BAR ON ERROR
    requestEnded();
    return Promise.reject(error);
  }
);

// Progress bar interceptors - response
axiosInstance.interceptors.response.use(
  (response) => {
    // END PROGRESS BAR ON SUCCESS
    requestEnded();
    return response;
  },
  (error) => {
    // END PROGRESS BAR ON ERROR
    requestEnded();
    // Global session-expiry handling — log out when the token is rejected
    handleUnauthorized(error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
